import React from "react";
import { gettext } from "web/script/modules/django-i18n";
import BranchLink from "web/react/components/branch-link/branch-link";
import GenericModal from "web/react/components/generic-modal/generic-modal";
import analytics from "web/script/analytics/analytics";
import styles from "./send-to-app-modal.css";

interface SendToAppModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    url: string;
    analyticsEventLabel: string;
}

function SendToAppModal({
    isOpen,
    onClose,
    title,
    url,
    analyticsEventLabel,
}: SendToAppModalProps): JSX.Element {
    function onModalClose(): void {
        analytics.event("app_overlay", "modal_dismissed", analyticsEventLabel);
        onClose();
    }

    return (
        <GenericModal isOpen={isOpen} onClose={onModalClose}>
            <div className={styles.content}>
                <h1 className={styles.title}>{title}</h1>
                <div role="presentation" className={styles.img} />
                <BranchLink
                    // "Download the Lyst App for free"
                    title={gettext("feed.show_more.app_overlay.cta")}
                    className={styles.button}
                    branchLink={url}
                    eventCategory={"app_overlay_cta"}
                    eventAction={"click_cta"}
                    eventLabel={analyticsEventLabel}
                    primaryButton
                />
            </div>
        </GenericModal>
    );
}

export default SendToAppModal;
